import {html} from '@isceco/widget-library2/external/lit'
import {unsafeHTML} from '@isceco/widget-library2/external/lit/directives/unsafe-html.js'
import {sanitizeRichTextHtml} from './utils.js'

export function renderKontakteContent(ctx, helpers) {
  const {
    renderContactList,
    renderHintAccordionsByItems,
    createHintItem,
    noContactAvailableI18nKey
  } = helpers

  const meta = ctx.selectedContractMeta
  const selectedTreffer = ctx.getSelectedTreffer()
  const typ = meta?.typ || selectedTreffer?.typ
  const isNav = typ === 'NAV'
  const contractContacts = renderContactList(ctx.contractParitaetContacts)
    || (meta?.weitereAuskunfte
      ? unsafeHTML(sanitizeRichTextHtml(meta.weitereAuskunfte))
      : '')
  const cantonalContacts = renderContactList(ctx.noMatchContacts)
  const hintItems = [
    createHintItem('personalverleih'),
    createHintItem('rechtlicherHinweis')
  ]

  return html`
    <div class="detail-content-section">
      <div class="contacts-block">
        <isceco-card>
          <div class="contacts-card-content">
            <h3>${ctx.i18n.translate('mindestlohnrechner.details.contacts.forYouResponsible')}</h3>
            ${!isNav
              ? html`
                <div class="contacts-contract-row contacts-subsection">
                  <p class="contacts-subsection-title">${ctx.i18n.translate('mindestlohnrechner.details.contacts.forContractQuestions')}</p>
                  <div>${contractContacts || html`<p>${ctx.i18n.translate(noContactAvailableI18nKey)}</p>`}</div>
                </div>
              `
              : ''}
            <div class="contacts-authorities-section">
              <div class="contacts-card-column contacts-subsection">
                <p class="contacts-subsection-title">${ctx.i18n.translate('mindestlohnrechner.details.contacts.cantonalAuthorities')}</p>
                ${cantonalContacts || html`<p>${ctx.i18n.translate(noContactAvailableI18nKey)}</p>`}
              </div>
            </div>
          </div>
        </isceco-card>
      </div>

      ${renderHintAccordionsByItems(ctx, hintItems, 'kontakte')}
    </div>
  `
}
